module.exports = __webpack_public_path__ + "static/ranking3.e3a0939a.svg";